module.exports = {

    props: {
        redirectUrl: {
            required: true,
        }
    },

    methods: {
        isUploaded() {
            if (this.redirectUrl) {
                this.redirectTo(this.redirectUrl)
            }
        }
    },
}
